<template>
  <mobile-responsive-shell title="Paiements fournisseurs">
    <div class="pay-m">
      <div class="pay-m-toolbar">
        <button type="button" class="btn btn-outline-secondary btn-sm" @click="refresh"><i class="bi bi-arrow-clockwise"></i></button>
        <button type="button" class="btn btn-outline-secondary btn-sm" @click="printList"><i class="bi bi-printer"></i></button>
        <button type="button" class="btn btn-primary btn-sm" @click="$router.push({ name: 'mobile-payments-suppliers-create' })"><i class="bi bi-plus-lg"></i> Paiement</button>
        <button type="button" class="btn btn-outline-secondary btn-sm" :class="{ active: showFilters }" @click="showFilters = !showFilters"><i class="bi bi-funnel"></i></button>
      </div>
      <div v-show="showFilters" class="pay-m-filters card card-body py-3 mb-3">
        <div class="mb-2">
          <label class="form-label small mb-0">Fournisseur</label>
          <select v-model="filter.supplier_reference" class="form-select form-select-sm">
            <option value="">—</option>
            <option v-for="s in suppliers" :key="s.reference" :value="s.reference">{{ s.fullName || s.society }}</option>
          </select>
        </div>
        <div class="row g-2 mb-2">
          <div class="col-6"><label class="form-label small mb-0">Du</label><input v-model="filter.startDate" type="date" class="form-control form-control-sm" /></div>
          <div class="col-6"><label class="form-label small mb-0">Au</label><input v-model="filter.endDate" type="date" class="form-control form-control-sm" /></div>
        </div>
        <div class="d-flex gap-2">
          <button type="button" class="btn btn-primary btn-sm flex-fill" @click="applyFilter">Appliquer</button>
          <button type="button" class="btn btn-outline-secondary btn-sm flex-fill" @click="resetFilter">Réinit.</button>
        </div>
      </div>
      <p v-if="!payments || !payments.length" class="text-muted text-center py-4">Aucun paiement.</p>
      <article v-for="(row, idx) in payments" :key="row.reference || idx" class="pay-m-card">
        <header class="pay-m-head">
          <span class="pay-m-ref">{{ row.reference }}</span>
          <button type="button" class="btn btn-sm btn-outline-primary" @click="goDetails(row)"><i class="bi bi-eye"></i></button>
        </header>
        <div class="pay-m-meta">{{ supplierLabel(row) }} · {{ row.date || "—" }}</div>
        <div class="pay-m-stats">
          <div><span class="lbl">M. facture</span><span v-if="row.purchase && row.purchase.totalPriceTTC >= 0">{{ fmt(row.purchase.totalPriceTTC) }}</span><span v-else>—</span></div>
          <div><span class="lbl">Mode</span><span class="text-primary">{{ row.paymentMethod || "—" }}</span></div>
          <div><span class="lbl">Payé</span><span class="text-success fw-semibold">{{ fmt(row.amount) }}</span></div>
          <div><span class="lbl">Impayé</span><span class="text-danger">{{ fmt(row.remainingAmount) }}</span></div>
        </div>
        <div v-if="row.remark" class="pay-m-remark small text-muted">{{ row.remark }}</div>
      </article>
      <div v-if="payments && payments.length" class="pay-m-summary">
        <div>Payé Σ <strong>{{ fmt(sumPaid) }}</strong></div>
        <div>Impayé Σ <strong>{{ fmt(sumRemaining) }}</strong></div>
      </div>
    </div>
  </mobile-responsive-shell>
</template>
<script>
import { mapGetters } from "vuex";
import MobileResponsiveShell from "../../components/MobileResponsiveShell.vue";
function defaultFilter() {
  const y = new Date().getFullYear();
  const d = new Date(new Date().setFullYear(y)).toLocaleString("en-CA").split(",")[0];
  return { supplier_reference: "", startDate: d, endDate: d };
}
export default {
  name: "MobilePaymentsSuppliersListing",
  components: { MobileResponsiveShell },
  data() {
    return { showFilters: false, filter: defaultFilter() };
  },
  computed: {
    ...mapGetters("payment", { payments: "getAll" }),
    ...mapGetters("supplier", { suppliers: "getAll" }),
    sumPaid() {
      if (!this.payments || !this.payments.length) return 0;
      return this.payments.reduce((a, r) => a + parseFloat(r.amount || 0), 0);
    },
    sumRemaining() {
      if (!this.payments || !this.payments.length) return 0;
      return this.payments.reduce((a, r) => a + parseFloat(r.remainingAmount || 0), 0);
    },
  },
  mounted() {
    this.$store.dispatch("payment/fetchPaymentSupplier");
    this.$store.dispatch("supplier/getAll");
  },
  methods: {
    fmt(v) {
      if (v === undefined || v === null || v === "") return "—";
      const n = parseFloat(v);
      return Number.isNaN(n) ? String(v) : n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    supplierLabel(row) {
      if (row.supplier) return (row.supplier.fullName || "") + " " + (row.supplier.society || "");
      return row.supplierFullName || "—";
    },
    async refresh() {
      this.filter = defaultFilter();
      await this.$store.dispatch("payment/fetchPaymentSupplier");
    },
    async applyFilter() {
      await this.$store.dispatch("payment/filter", { ...this.filter });
    },
    async resetFilter() {
      this.filter = defaultFilter();
      await this.$store.dispatch("payment/fetchPaymentSupplier");
    },
    async printList() {
      await this.$store.dispatch("payment/print", { ...this.filter });
    },
    goDetails(row) {
      this.$router.push({ name: "mobile-payments-suppliers-details", params: { reference: row.reference } });
    },
  },
};
</script>
<style scoped>
.pay-m-toolbar{display:flex;flex-wrap:wrap;gap:0.5rem;margin-bottom:0.75rem}
.pay-m-filters{border-radius:12px;border:1px solid rgba(0,0,0,.08)}
.pay-m-card{background:#fff;border-radius:12px;padding:.875rem 1rem;margin-bottom:.65rem;box-shadow:0 2px 8px rgba(0,0,0,.06);border:1px solid rgba(0,0,0,.06)}
.pay-m-head{display:flex;justify-content:space-between;align-items:center;gap:.5rem;margin-bottom:.35rem}
.pay-m-ref{font-weight:700;font-size: 1.1rem;word-break:break-all}
.pay-m-meta{font-size: 1rem;color:#495057;margin-bottom:.5rem}
.pay-m-stats{display:grid;grid-template-columns:1fr 1fr;gap:.35rem .75rem;font-size: 1rem}
.pay-m-stats .lbl{display:block;font-size: 0.8rem;text-transform:uppercase;color:#6c757d}
.pay-m-remark{margin-top:.5rem;padding-top:.5rem;border-top:1px solid #eee}
.pay-m-summary{margin-top:1rem;padding:.75rem;background:#f8f9fa;border-radius:10px;font-size: 1rem;display:grid;grid-template-columns:1fr 1fr;gap:.35rem}
</style>
